import { whistleblowerRetaliationReason } from '../../../../choices'
import { choicePage } from '../../../../pages'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

export const retaliationReasonsPage = () => {
  const props = {
    pageId: 'retaliation_reasons_page',
    fieldName: 'retaliation_reason',
    label: 'Why do you believe you suffered the retaliatory action(s)?',
    className: css.choices,
    labelClassName: css.largeLabel,
    choices: whistleblowerRetaliationReason()
  }

  const page = choicePage({ ...props })

  return {
    ...page,
    action: {
      type: 'goto',
      pageId: values => {
        const page = {
          'Perceived report of fraud, waste, or abuse': 'employment_page',
          'No particular reason': 'retaliation_reason_warning_page',
          Other: 'retaliation_reason_warning_page' //eslint-disable-line
        }

        return page.hasOwnProperty(values.retaliation_reason)
          ? page[values.retaliation_reason]
          : 'protected_disclosure_page'
      }
    }
  }
}
